export const links = [
  { name: "Home", to: "/home" },
  { name: "Explore", to: "/explore" },
  { name: "Engage", to: "/engage" },
  { name: "Connect", to: "/connect" },
];

export const NotificationRouteMap = {
  1: "/person-profile",
  2: "/explore",
  3: "/blog",
  4: "/success-stories",
  5: "/connect",
  6: "/plans",
  7: "/engage",
  8: "/connect",
  9: "/connect",
  10: "/engage",

  // TODO: Check these
  11: "/engage",
  12: "/engage",
  13: "/engage",
  14: "/engage",
  15: "/engage",
  16: "/connect",
  17: "/connect",

  18: "/notifications/diwali",
  19: "/notifications/christmas",
  20: "/notifications/holi",
  21: "/notifications/dussehra",
  22: "/notifications/doctors-day",
  23: "/notifications/teachers-day",
  24: "/notifications/mens-day",
  25: "/notifications/womens-day",
  26: "/engage",
  27: "/engage",
  28: "/my-profile",
  29: "/onboard/upload",
  30: "/plans",
};
